import type {Page} from '@PosterWhiteboard/page/page.class';
import type {ItemType} from '@PosterWhiteboard/items/item/item.types';
import type {CanvasEvents} from '@postermywall/fabricjs-2';
import {ActiveSelection} from '@postermywall/fabricjs-2';

export class GroupDrillIn {
  private page: Page;

  public constructor(page: Page) {
    this.page = page;
  }

  public onMouseUp(e: CanvasEvents['mouse:up']): void {
    this.tryDrillIn(e);
    this.enableSubTargetCheck();
  }

  public isActive(): boolean {
    return this.getDrilledGroupItem() !== undefined;
  }

  public getDrilledGroupItem(): {item: ItemType; groupId: string} | undefined {
    const selected = this.page.activeSelection.getActiveObjects();
    if (selected.length !== 1) {
      return undefined;
    }
    const item = this.page.getItemForFabricObject(selected[0]);
    if (!item?.groupId) {
      return undefined;
    }
    return {item, groupId: item.groupId};
  }

  private tryDrillIn(e: CanvasEvents['mouse:up']): void {
    if (!e.isClick) {
      return;
    }
    if (this.page.longPressInitiated) {
      return;
    }
    const fullGroupId = this.page.items.groups.getExclusivelySelectedGroupId();
    if (!fullGroupId) {
      return;
    }
    const nativeEvent = e.e;
    if (nativeEvent instanceof MouseEvent && nativeEvent.button !== 0) {
      return;
    }
    const subTarget = e.subTargets?.[0];
    if (!subTarget) {
      return;
    }
    const item = this.page.getItemForFabricObject(subTarget);
    if (item?.groupId !== fullGroupId) {
      return;
    }

    this.page.activeSelection.setActiveObject(subTarget);
  }

  public enableSubTargetCheck(): void {
    const activeObject = this.page.activeSelection.getActiveObject();
    if (activeObject instanceof ActiveSelection) {
      activeObject.subTargetCheck = this.page.items.groups.isSelectionExactlyOneGroup();
    }
  }
}
